import React from 'react'
import { useState} from 'react'
import { useTranslation } from 'react-i18next'
import PricingTable from '.'
import Section from '../Div'
import Spacing from '../Spacing'
import { useBtcRate } from '../../BtcRateContext';

export default function PricingTableList() {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';
  const [tab, setTab] = useState('monthly')
  const [currency, setCurrency] = useState('CZK')
  const btcRate = useBtcRate();

  const convertToBtc = (value) => {
    return btcRate === 0 ? 0 : parseFloat(value/btcRate).toFixed(5);
  }

  return (
    <Section className="position-relative">
      <ul className="cs-tab_links cs-style1 cs-mp0 cs-primary_font">
        <li className={tab === 'monthly' ? "active" : ""} onClick={()=>setTab('monthly')}>{t('pricing.weekdays')}</li>
        <li className={tab === 'yearly' ? "active" : ""} onClick={()=>setTab('yearly')}>{t('pricing.weekends')}</li>
      </ul>

      <ul className="cs-tab_links cs-style-btc-czk cs-mp0 cs-primary_font">
        <li className={currency === 'BTC' ? "active" : ""} onClick={()=>setCurrency('BTC')}>Bitcoin</li>
        <li className={currency === 'CZK' ? "active" : ""} onClick={()=>setCurrency('CZK')}>CZK</li>
      </ul>

      <Section className="row">
        <Section className="col-lg-4">
          {tab==='monthly' && (
            <PricingTable
              title={t('pricing.studioRental')}
              subline={t('pricing.hourlyProjects')}
              price={currency === 'BTC' ? convertToBtc(300) : 300}
              currency={currency === 'BTC' ? ' BTC' : 'Kč'}
              timeline={t('pricing.hour')}
              features={[t('pricing.features.studioForProject'), t('pricing.features.idealForPodcasts'), t('pricing.features.fullEquipment'), t('pricing.features.trainingOptions')]}
              btnText={t('pricing.bookBtn')}
              btnLink={'/kontakt'}
            />
          )}
          {tab==='yearly' && (
            <PricingTable
              title={t('pricing.studioRental')}
              subline={t('pricing.hourlyProjects')}
              price={currency === 'BTC' ? convertToBtc(350) : 350}
              currency={currency === 'BTC' ? ' BTC' : 'Kč'}
              timeline={t('pricing.hour')}
              features={[t('pricing.features.studioForProject'), t('pricing.features.idealForPodcasts'), t('pricing.features.fullEquipment'), t('pricing.features.trainingOptions')]}
              btnText={t('pricing.bookBtn')}
              btnLink={'/kontakt'}
            />
          )}
          <Spacing lg='25' md='25'/>
        </Section>
        <Section className="col-lg-4">
         {tab==='monthly' && (
            <PricingTable
              title={t('pricing.dayRental')}
              subline={t('pricing.fullDay')}
              price={currency === 'BTC' ? convertToBtc(2000) : 2000}
              currency={currency === 'BTC' ? ' BTC' : 'Kč'}
              timeline={t('pricing.day')}
              features={[t('pricing.features.studioForProject'), t('pricing.features.fullEquipment'), t('pricing.features.accommodation'), t('pricing.features.trainingOptions'), t('pricing.features.technicalAssistance')]}
              btnText={t('pricing.bookBtn')}
              btnLink={'/kontakt'}
            />
          )}
          {tab==='yearly' && (
            <PricingTable
            title={t('pricing.dayRental')}
              subline={t('pricing.fullDay')}
              price={currency === 'BTC' ? convertToBtc(2500) : 2500}
              currency={currency === 'BTC' ? ' BTC' : 'Kč'}
              timeline={t('pricing.day')}
              features={[t('pricing.features.studioForProject'), t('pricing.features.fullEquipment'), t('pricing.features.accommodation'), t('pricing.features.trainingOptions'), t('pricing.features.technicalAssistance')]}
              btnText={t('pricing.bookBtn')}
              btnLink={'/kontakt'}
            />
          )}
          <Spacing lg='25' md='25'/>
        </Section>
        <Section className="col-lg-4">
          {tab==='monthly' && (
            <PricingTable
              title={t('pricing.fullService')}
              subline={t('pricing.completeServices')}
              price={currency === 'BTC' ? convertToBtc(650) : 650}
              currency={currency === 'BTC' ? ' BTC' : 'Kč'}
              timeline={t('pricing.perHour')}
              features={[t('pricing.features.production'), t('pricing.features.editing'), t('pricing.features.recording'), t('pricing.features.mixMaster'), t('pricing.features.arrangementConsultation'), t('pricing.features.accommodationIncluded')]}
              btnText={t('pricing.bookBtn')}
              btnLink={'/kontakt'}
            />
          )}
          {tab==='yearly' && (
            <PricingTable
            title={t('pricing.fullService')}
            subline={t('pricing.completeServices')}
            price={currency === 'BTC' ? convertToBtc(600) : 600}
            currency={currency === 'BTC' ? ' BTC' : 'Kč'}
            timeline={t('pricing.perHour')}
            features={[t('pricing.features.production'), t('pricing.features.editing'), t('pricing.features.recording'), t('pricing.features.mixMaster'), t('pricing.features.arrangementConsultation'), t('pricing.features.accommodationIncluded')]}
            btnText={t('pricing.bookBtn')}
            btnLink={'/kontakt'}
            />
          )}
          <Spacing lg='25' md='25'/>
        </Section>
      </Section>
      <Section className="row">
        <Section className="col-lg-8">
        <p>{t('pricing.studentDiscount')}</p>
        <p dangerouslySetInnerHTML={{ __html: t('pricing.accommodationNote') }}></p>
        </Section>
        </Section>
      </Section>
  )
}